import React from 'react';
import { HelpCircle } from 'lucide-react';

export default function WhyBox({ title, children }) {
  return (
    <div className="bg-[#FFC107]/10 border-2 border-[#FFC107]/40 rounded-xl p-4 mb-4" data-testid="why-box">
      <div className="flex items-start gap-2.5">
        <div className="w-7 h-7 bg-[#FFC107] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 border border-[#2A2A2A]/20">
          <HelpCircle className="w-4 h-4 text-[#2A2A2A]" />
        </div>
        <div>
          <p className="text-sm font-bold text-[#2A2A2A] mb-1" style={{ fontFamily: "'Bebas Neue', cursive", letterSpacing: '0.03em' }}>
            {title || 'Why This Matters'}
          </p>
          <div className="text-sm text-[#2A2A2A]/70 leading-relaxed space-y-2">{children}</div>
        </div>
      </div>
    </div>
  );
}
